<!--
    ChoosePage.vue
    Core of the SPA. Asks a series of statistical questions to narrow down list
    by Guy E. White <guw968@g.harvard.edu>
-->

<template>
    <div id='tests'>
        <h2>Choose a Statistical Test</h2>

        <!-- Question 0 -->
        <div v-if='showQuestion0'>
            <div class='question'>
                <h3>Welcome! This interview will help you find statistical tests that can be used in your research. To begin, click "Begin Interview."</h3>

                <button data-test='begin-interview' v-on:click='submitQuestion0'>Begin Interview</button>
            </div>
        </div>

        <!-- Question 1 -->
        <div v-if='showQuestion1'>
            <div class='question'>
                <h3>I want to...</h3>
                <p><label><input data-test='option1' type='radio' id='a' value='a' v-model.lazy='question1' checked > compare two or more groups scores at one occasion of measurement.</label></p>
                <p><label><input data-test='option2' type='radio' id='b' value='b' v-model.lazy='question1'> compare the scores of one or more group(s) over multiple occasions of measurement.</label></p>
                <p><label><input data-test='option3' type='radio' id='c' value='c' v-model.lazy='question1'> anaylze the relationships between variables of one group.</label></p>
                <p><label><input data-test='option4' type='radio' id='d' value='d' v-model.lazy='question1'> describe the scores of one group.</label></p>

                <button data-test='submit-question-1' v-on:click='submitQuestion1'>Next Step</button>
            </div>
        </div>

        <!-- Question 2 -->
        <div v-if="showQuestion2 == true && tests.length > 0">
            <div class='question'>
                <h3>How many groups am I measuring?</h3>
                <p><label><input type='radio' id='a' value='a' v-model.lazy='question2' checked > One group.</label></p>
                <p><label><input type='radio' id='b' value='b' v-model.lazy='question2'> Two groups.</label></p>
                <p><label><input type='radio' id='c' value='c' v-model.lazy='question2'> Two or more groups.</label></p>

                <button v-on:click='submitQuestion2'>Next Step</button>
            </div>
        </div>

        <!-- Question 3 -->
        <div v-if='showQuestion3 == true && tests.length > 0'>
            <div class='question'>
                <h3>What is the level of measurement of my dependent variable(s)?</h3>
                <p><label><input type='radio' id='a' value='a' v-model.lazy='question3' checked > Nominal.</label></p>
                <p><label><input type='radio' id='b' value='b' v-model.lazy='question3'> Ordinal.</label></p>
                <p><label><input type='radio' id='c' value='c' v-model.lazy='question3'> Interval.</label></p>

                <button v-on:click='submitQuestion3'>Next Step</button>
            </div>
        </div>

        <!-- Question 4 -->
        <div v-if='showQuestion4 == true && tests.length > 0'>
            <div class='question'>
                <h3>What is the level of measurement of my independent variable(s)?</h3>
                <p><label><input type='radio' id='a' value='a' v-model.lazy='question4' checked > Nominal.</label></p>
                <p><label><input type='radio' id='b' value='b' v-model.lazy='question4'> Ordinal.</label></p>
                <p><label><input type='radio' id='c' value='c' v-model.lazy='question4'> Interval.</label></p>

                <button v-on:click='submitQuestion4'>Next Step</button>
            </div>
        </div>

        <!-- Question 5 -->
        <div v-if='showQuestion5 == true && tests.length > 0'>
            <div class='question'>
                <h3>What is the level of measurement of my independent variable(s)?</h3>
                <p><label><input type='radio' id='a' value='a' v-model.lazy='question5' checked > Two.</label></p>
                <p><label><input type='radio' id='b' value='b' v-model.lazy='question5'> Two or more.</label></p>
                <p><label><input type='radio' id='c' value='c' v-model.lazy='question5'> Three or more.</label></p>

                <button v-on:click='submitQuestion5'>Next Step</button>
            </div>
        </div>

        <div v-if="showQuestion0 != true && showQuestion1 != true">
            <h3>Tests That Meet Your Criteria</h3>

            <div v-if="tests.length > 0 || firstLoad == true">
                <show-test
                    v-for='test in tests'
                    :key='test.testName'
                    :test='test'
                ></show-test>
            </div>
            <div v-else>
                <h3>No Tests In Our Database Meet Your Critieria</h3>
                <button v-on:click='startOver'>Start Over</button>
            </div>
        </div>
    </div>
</template>

<script>
import ShowTestsDetailed from '@/components/ShowTestsDetailed.vue';
let _ = require('lodash');

export default {
    name: '',
    components: {
        'show-test': ShowTestsDetailed
    },
    props: [],
    data: function() {
        return {
            tests: [],
            firstLoad: true,
            testType: '',
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            showQuestion0: true,
            showQuestion1: false,
            showQuestion2: false,
            showQuestion3: false,
            showQuestion4: false,
            showQuestion5: false
        };
    },
    methods: {
        submitQuestion0: function () {
            this.firstLoad = false;
            this.showQuestion0 = false;
            this.tests = this.allTests;
            this.showQuestion1 = true;
        },
        submitQuestion1: function () {
            let question1 = this.question1;
            this.showQuestion1 = false;
            if (question1 == "a"){
                this.tests = _.filter(this.tests, { 'testType': 'Comparison'});
                this.showQuestion2 = true;
            } else if (question1 == "b") {
                this.tests = _.filter(this.tests, { 'testType': 'Repeated'});
                this.showQuestion2 = true;
            } else if (question1 == "c") {
                this.tests = _.filter(this.tests, { 'testType': 'Correlation'});
                this.showQuestion3 = true;
            } else if (question1 == "d") {
                this.tests = _.filter(this.tests, { 'testType': 'Descriptive'});
                this.showQuestion3 = true;
            }
        },
        submitQuestion2: function () {
            let question2 = this.question2;
            this.showQuestion2 = false;
            if (question2 == "a") {
                this.tests = _.filter(this.tests, { 'independentVariableNumberOfGroups': '1'});
            } else if (question2 == "b") {
                this.tests = _.filter(this.tests, { 'independentVariableNumberOfGroups': '2'});
            } else if (question2 == "c") {
                this.tests = _.filter(this.tests, { 'independentVariableNumberOfGroups': 'two or more'});
            }
            this.showQuestion3 = true;
        },
        submitQuestion3: function () {
            let question3 = this.question3;
            this.showQuestion3 = false;
            if (question3 == "a") {
                this.tests = _.filter(this.tests, { 'dependentVariableLevelofMeasurement': 'Nominal'});
            } else if (question3 == "b") {
                this.tests = _.filter(this.tests, { 'dependentVariableLevelofMeasurement': 'Ordinal'});
            } else if (question3 == "c") {
                this.tests = _.filter(this.tests, { 'dependentVariableLevelofMeasurement': 'Interval'});
            }

            // Decide upon next question to provide, if Question 1 was answered C, go to question 4
            if (this.question1 == "c") {
                this.showQuestion4 = true;
            } else {
                this.showQuestion5 = true;
            }
        },
        submitQuestion4: function () {
            let question4 = this.question4;
            this.showQuestion4 = false;
            if (question4 == "a") {
                this.tests = _.filter(this.tests, { 'independentVariableLevelOfMeasurement': 'Nominal'});
            } else if (question4 == "b") {
                this.tests = _.filter(this.tests, { 'independentVariableLevelOfMeasurement': 'Ordinal'});
            } else if (question4 == "c") {
                this.tests = _.filter(this.tests, { 'independentVariableLevelOfMeasurement': 'Interval'});
            }
            this.showQuestion5 = true;
        },
        submitQuestion5: function () {
            let question5 = this.question5;
            this.showQuestion5 = false;
            if (question5 == "a") {
                this.tests = _.filter(this.tests, { 'dependentVariableNumberOfOutcomes': '2'});
            } else if (question5 == "b") {
                this.tests = _.filter(this.tests, { 'dependentVariableNumberOfOutcomes': 'two or more'});
            } else if (question5 == "c") {
                this.tests = _.filter(this.tests, { 'dependentVariableNumberOfOutcomes': 'three or more'});
            }
        },
        startOver: function() {
            this.firstLoad = true;
            this.testType = '';
            this.question1 = '';
            this.question2 = '';
            this.question3 = '';
            this.question4 = '';
            this.question5 = '';
            this.showQuestion0 = true;
            this.showQuestion1 = false;
            this.showQuestion2 = false;
            this.showQuestion3 = false;
            this.showQuestion4 = false;
            this.showQuestion5 = false;
        }
    },
    mounted: function() {

    },
    computed: {
        loadTests: function() {
            return this.$store.state.products;
        },
        allTests: function() {
            let theseTests = {}
            for (let key of Object.keys(this.loadTests)) {
                theseTests[key] = this.loadTests[key];
            }
            return theseTests;
        }
    }
};
</script>

<style scoped>
</style>
